module.exports = __webpack_public_path__ + "img/shg50_samurai02_shop.f5a43665.png";